import React from 'react';
import { View } from 'react-native';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import ComponentSection from 'shared/renderer/GenericContainers/ComponentSection';
import {
  isVXLGenericSectionNodeType,
  VXLGenericSection,
  VXLSection,
} from 'shared/renderer/types';

import SectionRegistry from './SectionRegistry';

export interface SectionRendererProps {
  toRender: VXLSection | VXLGenericSection;
}

const SectionRenderer = ({ toRender }: SectionRendererProps) => {
  if (!toRender) {
    return null;
  }

  if (isVXLGenericSectionNodeType(toRender)) {
    return <ComponentSection {...(toRender.props as any)} />;
  }

  const Section = SectionRegistry[toRender.name];
  if (!Section) {
    return (
      <View>
        <BodyBaseText>oops! something went wrong</BodyBaseText>
      </View>
    );
  }

  return <Section {...(toRender.props as any)} />;
};

export default SectionRenderer;
